import { render, staticRenderFns } from "./AlimtalkReg.vue?vue&type=template&id=5978dee6"
import script from "./AlimtalkReg.vue?vue&type=script&lang=js"
export * from "./AlimtalkReg.vue?vue&type=script&lang=js"
import style0 from "./AlimtalkReg.vue?vue&type=style&index=0&id=5978dee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports